import { z } from 'zod';
import { QUOTE_STATUSES } from '@shared/constants';
import {
  calendarDateSchema,
  centsSchema,
  nonEmptyString,
  optionalText,
  uuidSchema,
} from './common';

export const quoteStatusSchema = z.enum(QUOTE_STATUSES);

/** A line item on a quote: a service with quantity and price. */
export const quoteLineItemSchema = z.object({
  serviceId: uuidSchema.optional(),
  description: nonEmptyString,
  quantity: z
    .number({ message: 'Enter a quantity' })
    .nonnegative({ message: 'Quantity must not be negative' })
    .default(1),
  unitPriceCents: centsSchema,
});

export const createQuoteSchema = z.object({
  customerId: uuidSchema,
  propertyId: uuidSchema.optional(),
  status: quoteStatusSchema.optional(),
  issueDate: calendarDateSchema,
  expirationDate: calendarDateSchema.optional(),
  customerMessage: optionalText,
  internalNotes: optionalText,
  items: z.array(quoteLineItemSchema).min(1, { message: 'Add at least one line item' }),
});

export const updateQuoteSchema = createQuoteSchema
  .partial()
  .refine((data) => Object.keys(data).length > 0, { message: 'Nothing to update' });

export type QuoteStatus = z.infer<typeof quoteStatusSchema>;
export type CreateQuoteInput = z.infer<typeof createQuoteSchema>;
export type UpdateQuoteInput = z.infer<typeof updateQuoteSchema>;
